/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Overview_Back_To_PlanningInputs */



/**
* | output |
* | --- |
* | "Back to Planning" |
*
* @param {Overview_Back_To_PlanningInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const overview_back_to_planning = /** @type {((inputs?: Overview_Back_To_PlanningInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Overview_Back_To_PlanningInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Retour à la planification")
	if (locale === "es") return /** @type {LocalizedString} */ ("Volver a planificación")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Voltar ao Planejamento")
	if (locale === "it") return /** @type {LocalizedString} */ ("Torna alla Pianificazione")
	return /** @type {LocalizedString} */ ("Back to Planning")
});